const config = {
  local: {
    apiGateway: {
      URL: 'http://localhost:3001',
      REGION: 'eu-west-3'
    },
    cognito: {
      REGION: 'eu-west-3',
      USER_POOL_ID: 'eu-west-3_UWW4wlczz',
      APP_CLIENT_ID: '3v0gbrmv32m2ikiifraj1eo9fm',
      IDENTITY_POOL_ID: 'eu-west-3:74b89a7f-bd51-47e6-b669-232f420bbbad'
    }
  },
  dev: {
    apiGateway: {
      URL: 'https://rcs.dev.tadoo.biz',
      REGION: 'eu-west-3'
    },
    cognito: {
      REGION: 'eu-west-3',
      USER_POOL_ID: 'eu-west-3_UWW4wlczz',
      APP_CLIENT_ID: '3v0gbrmv32m2ikiifraj1eo9fm',
      IDENTITY_POOL_ID: 'eu-west-3:74b89a7f-bd51-47e6-b669-232f420bbbad'
    }
  },
  prod: {
    apiGateway: {
      URL: 'https://rcs.tadoo.biz',
      REGION: 'eu-west-3'
    },
    cognito: {
      REGION: 'eu-west-3',
      USER_POOL_ID: 'eu-west-3_iS5G8xV8c',
      APP_CLIENT_ID: '1cr1mbvj9j2kftl263q1pvj82',
      IDENTITY_POOL_ID: 'eu-west-3:9cd5269a-bb78-4699-bd05-42d3f169fbb3'
    }
  }
}

// Determinar el stage:
// 1) Si se fuerza por variable de entorno (REACT_APP_STAGE), usarla.
// 2) Si no, detectar por URL en runtime.
// 3) Fallback a 'dev'.
let stage

// Prioridad 1: Forzar stage por variable de entorno (permite localhost -> prod/dev)
if (process.env.REACT_APP_STAGE && config[process.env.REACT_APP_STAGE]) {
  stage = process.env.REACT_APP_STAGE
}

// Prioridad 2: Detectar por URL en runtime
if (!stage && typeof window !== 'undefined') {
  const hostname = window.location.hostname
  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    stage = 'local'
  } else if (hostname.includes('dashboard.dev.tadoo.app')) {
    stage = 'dev'
  } else if (hostname.includes('tadoo.app')) {
    // Solo usar prod si es explícitamente tadoo.app o tadoo.biz (sin dev)
    if (!hostname.includes('dev.')) {
      stage = 'prod'
    }
  }
}

// Prioridad 3: Compatibilidad si llega un stage no validado arriba
if (!stage) {
  stage = process.env.REACT_APP_STAGE
}

// Fallback a 'dev' si no se puede determinar (más seguro que 'local' para producción)
stage = stage || 'dev'
const stageConfig = config[stage] || config.dev

// Permite forzar solo la URL de API (manteniendo Cognito según stage)
const apiUrlOverride = process.env.REACT_APP_API_URL

export default {
  ...stageConfig,
  apiGateway: {
    ...stageConfig.apiGateway,
    URL: apiUrlOverride || stageConfig.apiGateway.URL
  }
}
